import React, { Component } from 'react';
import _ from 'lodash';
import { Sparklines, SparklinesLine } from 'react-sparklines';
import PortfolioWeight from '../components/portfolio-weight.js'
import PortfolioGains from '../components/portfolio-gains.js'
import StatLegend from '../components/stat.js'
import axios from 'axios';
import SymbolLink from '../components/symbol-link.js'
import CircularProgressbar from 'react-circular-progressbar';
import { db } from '../firebase';

export default class Home extends Component {

    constructor() {
        super();
        this.state = {
            positions: [],
            charts: [],
            today: false
        }
    }

    async  componentDidMount() {

        let items = await db.getPosition();
        this.getLastestPrices(items.filter(a => a.quantity > 0), items.filter(a => a.quantity == 0));
    }

    async  getLastestPrices(items, closed_positions) {

        let prices = await axios.get('https://api.iextrading.com/1.0/stock/market/batch?types=price,previous,company,stats&symbols=' + items.map(a => a.symbol).join(","));
        if (prices && prices.data) {

            items = items.map(a => {


                a.last_price = prices.data[a.symbol] ? prices.data[a.symbol].price : 0;
                a.unrealized_gains = a.last_price > 0 ? ((a.last_price - a.price) * a.quantity) : a.quantity * a.price * -1;
                a.prev_closing_price = prices.data[a.symbol] ? prices.data[a.symbol].previous.close : 0;
                a.today_gains = a.last_price > 0 ? ((a.last_price - a.prev_closing_price) * a.quantity) : 0;
                if (!prices.data[a.symbol]) {
                    prices.data[a.symbol] = {};
                }
                return { ...a, ...prices.data[a.symbol].company, ...prices.data[a.symbol].stats }
            });
        }

        this.setState({

            closed_positions: closed_positions,
            positions: _.orderBy(items.map((pos_item) => {

                pos_item.total_invested = pos_item.quantity * pos_item.price;
                return pos_item;
            }), "total_invested", "desc")
        });
        // this.loadSparklines("3m");
        // this.loadSparklines("1m");
    }

    async  loadSparklines(range) {

        let chart_data = await axios.get('https://api.iextrading.com/1.0/stock/market/batch?types=chart&range=' + range + '&symbols=' + this.state.positions.map(a => a.symbol).join(","));
        if (chart_data && chart_data.data) {

            this.setState({
                positions: this.state.positions.map((pos_item) => {

                    pos_item["chart" + range] = chart_data.data[pos_item.symbol] ? chart_data.data[pos_item.symbol].chart.map(a => { return a.close }) : null;
                    return pos_item;
                })
            });
        }
    }

    render() {

        if (this.state.positions && this.state.positions.length) {

            let master_total = (this.state.positions && this.state.positions.length) ? this.state.positions.reduce((acc, curr) => {

                return acc + (curr.quantity * curr.price);
            }, 0) : 0;

            let colors = ["#ff9e40", "#ff6284", "#5cbae6", "#b6d957", "#fac364", "#d998cb", "#f2d249", "#93b9c6", "#ccc5a8",
                "#52bacc", "#dbdb46", "#98aafb", "#aaeeee", "#36a1ec"];

            let symbol_colors = {};
            let color_index = -1;
            for (var pos_item of this.state.positions) {

                color_index = color_index + 1;
                symbol_colors[pos_item.symbol] = colors[color_index]
            }

            let total_unrealized_gains = (this.state.positions && this.state.positions.length) ? this.state.positions.reduce((acc, curr) => {


                return acc + curr.unrealized_gains;
            }, 0) : 0;
            let total_today_unrealized_gains = (this.state.positions && this.state.positions.length) ? this.state.positions.reduce((acc, curr) => {


                return acc + (curr.last_price - curr.prev_closing_price) * curr.quantity;
            }, 0) : 0;

            let total_gain_percent = ((total_unrealized_gains * 100) / master_total).toFixed(2);
            let today_total_gain_percent = ((total_today_unrealized_gains * 100) / master_total).toFixed(2);

            let total_fees = _.sumBy(this.state.closed_positions, "fees") + _.sumBy(this.state.closed_positions, "fees");
            let total_div = _.sumBy(this.state.positions, "dividends") + _.sumBy(this.state.closed_positions, "dividends");
            let total_realized_gains = _.sumBy(this.state.positions, "gains") + _.sumBy(this.state.closed_positions, "gains") + total_div - total_fees;

            return (
                <div className="ss-container-stacked ss-page">
                    <nav className="navbar is-transparent ss-fixed-row" style={{ height: "72px", borderBottom: "1px solid #dbdbdb" }}>
                        <div class="navbar-brand">
                            <a class="navbar-item">
                                <img src="https://www.iconexperience.com/_img/g_collection_png/standard/512x512/spreadsheet.png" />
                            </a>
                        </div>
                        <div className="navbar-start">
                            <div className="navbar-item">
                                <div>
                                    <p className="title is-4">Home</p>
                                </div>
                            </div>
                        </div>
                    </nav>
                    <div className="ss-fluid-row">
                        <div className="section ss-fixed-row" style={{ backgroundColor: "hsl(0, 0%, 96%)", paddingBottom: 0 }}>
                            <div class="columns ">
                                <div class="column">
                                    <StatLegend
                                        color={total_today_unrealized_gains > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                        value={"$" + total_today_unrealized_gains.toFixed(2)}
                                        value_secondary={today_total_gain_percent + "%"}
                                        label="Today P/L" />
                                </div>

                                <div class="column">
                                    <StatLegend
                                        color={total_unrealized_gains > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                        value={"$" + total_unrealized_gains.toFixed(2)}
                                        value_secondary={total_gain_percent + "%"}
                                        label="Unrealized P/L" />
                                </div>
                                <div class="column">
                                    <StatLegend
                                        color={total_realized_gains > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                        value={"$" + total_realized_gains.toFixed(2)}
                                        label="Realized P/L" />
                                </div>
                                <div class="column">
                                    <StatLegend
                                        color={total_div > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)"}
                                        value={"$" + total_div.toFixed(2)}
                                        label="Dividends" />
                                </div>
                            </div>
                        </div>

                        <section className="section ss-container-stacked" style={{ backgroundColor: "rgb(245, 245, 245)" }} >

                            <div class="card">
                                <div class="card-content">
                                    <div class="columns">
                                        <div class="column">
                                            <p class="title is-4">Allocation</p>
                                            <PortfolioWeight positions={this.state.positions} symbol_colors={symbol_colors} />
                                        </div>
                                        <div class="column" style={{ borderLeft: "1px solid #e8e8e8" }}>
                                            <div class="level">
                                                <div class="level-left">
                                                    <div class="level-item">
                                                        <h1 class="title is-4">Net Gains</h1>
                                                    </div>
                                                </div>
                                                <div class="level-right">
                                                    <div class="level-item">
                                                        <div class="tabs is-toggle is-toggle-rounded">
                                                            <ul>
                                                                <li className={this.state.today === true ? "is-active" : ""} onClick={() => this.setState({ today: true })}><a>Today</a></li>
                                                                <li className={this.state.today === false ? "is-active" : ""} onClick={() => this.setState({ today: false })}><a>All</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <PortfolioGains today={this.state.today} positions={this.state.positions} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card ss-fluid-row">
                                <table className="table table is-narrow is-fullwidth table is-hoverable">
                                    <thead>
                                        <th>Symbol</th>
                                        <th>Sector</th>
                                        <th><span className="is-pulled-right">Return (%)</span></th>
                                        <th><span className="is-pulled-right">Quantity</span></th>
                                        <th><span className="is-pulled-right">Current / Buy Price ($)</span></th>
                                        <th><span className="is-pulled-right">Value / Invested ($)</span></th>
                                        <th><span className="is-pulled-right">52 Week Range </span></th>
                                        <th><span className="is-pulled-right">Weight </span></th>
                                        {/* <th><span className="is-pulled-right">1 month</span></th>
                                    <th><span className="is-pulled-right">3 month</span></th> */}
                                    </thead>
                                    <tbody>
                                        {this.state.positions.map(function (pos_item, i) {
                                            let price_chage = pos_item.last_price - pos_item.price;
                                            let current_value = pos_item.last_price * pos_item.quantity;
                                            let value_change = current_value - pos_item.total_invested;
                                            let weight = (current_value / master_total) * 100;
                                            return <tr>
                                                <td style={{ verticalAlign: "middle" }}><i class="fa fa-circle" aria-hidden="true" style={{ "marginRight": "0.75em", color: symbol_colors[pos_item.symbol] }}></i>
                                                    <SymbolLink symbol={pos_item.symbol} />
                                                </td>
                                                <td style={{ verticalAlign: "middle" }}>{pos_item.sector ? pos_item.sector : '-'}</td>
                                                <td style={{ verticalAlign: "middle" }}>
                                                    <span className="is-pulled-right ">
                                                        <span className={"tag is-medium " + (price_chage > 0 ? "is-success" : "is-danger")}>
                                                            {((value_change * 100) / pos_item.total_invested).toFixed(2)}%
                                                </span>
                                                    </span>
                                                </td>
                                                <td style={{ verticalAlign: "middle" }}><span className="is-pulled-right">{pos_item.quantity}</span></td>
                                                <td style={{ verticalAlign: "middle" }}>
                                                    <span className="is-pulled-right ">${pos_item.price.toFixed(2)}</span>
                                                    <br />
                                                    <span className="is-pulled-right ">
                                                        <span className={price_chage > 0 ? "has-text-success" : "has-text-danger"}>({price_chage > 0 ? "+" : ""}${price_chage.toFixed(2)}) </span>
                                                        ${pos_item.last_price}</span>

                                                </td>
                                                <td style={{ verticalAlign: "middle" }}>
                                                    <span className="is-pulled-right">${pos_item.total_invested.toFixed(2)}</span>
                                                    <br />
                                                    <span className="is-pulled-right">
                                                        <span className={value_change > 0 ? "has-text-success" : "has-text-danger"}>({value_change > 0 ? "+" : ""}${value_change.toFixed(2)}) </span>
                                                        ${current_value.toFixed(2)}
                                                    </span>
                                                </td>

                                                <td style={{ verticalAlign: "middle" }} >
                                                    <progress title={pos_item.week52low ? (pos_item.week52low + " - " + pos_item.week52high) : '-'} class="progress is-info" value={(pos_item.last_price * 100) / pos_item.week52high} max="100"></progress>
                                                </td>
                                                <td style={{ verticalAlign: "middle" }} >
                                                    <span className="is-pulled-right">
                                                        {weight.toFixed(2)}%
                                                     {/* <CircularProgressbar percentage={weight.toFixed(0)} />  */}
                                                    </span>
                                                </td>
                                                {/* <td>
                                                {pos_item.chart1m && pos_item.chart1m.length > 1 ?
                                                    <Sparklines data={pos_item.chart1m} style={{ fill: "none" }}>
                                                        <SparklinesLine />
                                                    </Sparklines> : '-'}
                                            </td>
                                            <td>
                                                {pos_item.chart3m && pos_item.chart3m.length > 1 ?
                                                    <Sparklines data={pos_item.chart3m} style={{ fill: "none" }}>
                                                        <SparklinesLine />
                                                    </Sparklines> : '-'}
                                            </td> */}

                                            </tr>
                                        })}
                                    </tbody>

                                </table>
                            </div>
                        </section >
                    </div>
                </div>)
        }
        else {
            return <div></div>
        }
    }
}


// WEBPACK FOOTER //
// ./src/containers/home.js